import { render, staticRenderFns } from "./ClientEmailNotificationFormManualNotification.vue?vue&type=template&id=18f44377&"
import script from "./ClientEmailNotificationFormManualNotification.vue?vue&type=script&lang=js&"
export * from "./ClientEmailNotificationFormManualNotification.vue?vue&type=script&lang=js&"
import style0 from "./ClientEmailNotificationFormManualNotification.vue?vue&type=style&index=0&id=18f44377&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports